import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ModalComponent } from '../../../core/config/core.modal-helpers';
import * as _ from 'lodash';

@Component({
  selector: 'thread-edit-modal',
  template: require('./forum.thread-edit-modal.component.html')
})
export class ThreadEditModalComponent extends ModalComponent implements OnInit {
  @Input() discussion: any;
  @Input() thread: any;
  @Input() postThread: any;

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  title: string;
  YesNo = {
    'Yes': 'Y',
    'No': 'N'
  };

  constructor() { 
    super();
  }

  ngOnInit() {
    this.title = this.thread.id > 0 ? 'Edit thread' : 'Add thread';
  }

  post() {
    this.postThread(this.thread);
    this.onClose.emit();
  }

  doCloseModal() {
    this.onClose.emit();
  }

  setConfigValue(path: string, value: any) {
    if (value == undefined || value == _.get(this, path)) return false;
    _.set(this, path, value);
  }
}

export default ThreadEditModalComponent;